// TestMap.jsx
import React from "react";
import { GoogleMap, LoadScript } from "@react-google-maps/api";

const containerStyle = { width: "100%", height: "400px" };
const center = { lat: 19.076, lng: 72.8777 }; // Example: Mumbai

export const TestMap1 = () => {
    return (
        <LoadScript googleMapsApiKey="AIzaSyC16Y-R8bhKWx57M63qEGelyGB3SRfxFIU">
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={12}
            >
                {/* Map loaded! */}
            </GoogleMap>
        </LoadScript>
    );
};

export default TestMap1;
